import * as React from "react"
import styled from 'styled-components';
import { Container } from "react-bootstrap";
import medal_4 from '../../images/hubspot_badge.webp'

const StyledContainer = styled(Container)`
  .fixed-image {   
    position: fixed;
    margin-right: 0;
    margin-left: auto;
    margin-top: 150px;
    right: 0;
    z-index: 999;
  }

  @media(max-width: 768px){
    .fixed-image{
      display:none;
    }
  }
`
const FixedBadge = () => {
  return (
    <StyledContainer>
      <div className="">
        <a href="/certified-app-in-hubspot-app-marketplace/" aria-label="Clearout is now a certified app in HubSpot App Marketplace">
          <img 
            loading="lazy" 
            className="fixed-image" 
            src={medal_4}
            alt="email-finder"
            width={120}
          />
        </a>
      </div>
    </StyledContainer>
  )
}

export default FixedBadge;